import template from './global-method-selector.html';

export default angular
  .module('app.holding.dashboard.funds')
  .directive('holdingGlobalMethodSelector', holdingGlobalMethodSelector)
  .name;

function holdingGlobalMethodSelector() {
  'ngInject';

  return {
    link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      options: '=',
    },
    template,
  };

  function link(scope, _elem, _attrs, ngModel) {
    function select(option) {
      if (option.available !== false) {
        ngModel.$setViewValue(option.id);
      }
    }

    scope.model = ngModel;
    scope.select = select;
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/funds/directives/global-method-selector/global-method-selector.js